import { actions } from '@sloyd/store-base';
import { bridge } from '@sloyd/viewer';
import { delay, put, takeEvery } from 'saga-ts';
import { $a } from 'shared-base';
import { predicateCurrentIds } from './helpers/predicates';

export const saga = {
  id: 'sloyd.predicates',
  type: 'entity',
  root: root,
  trigger: {},
};

export function* onProjectChange(action: any) {
  const { payload } = action;
  const { projectId } = payload;

  if (!projectId) {
    yield put(actions.appState.patch({ currentBarIndex: 0 }));
    return;
  }
}
export function* onModelChange(action: any) {
  const { payload } = action;
  const { modelId } = payload;

  if (modelId === 'new-model' || !modelId) {
    bridge.clear('main');
    return;
  }

  yield put($a('MODELS', 'load', modelId));
}

export function* onRefresh() {
  yield delay(20);
  yield put(actions.currentIds.patch({ randomId: Math.random() }));
}

export function* root() {
  yield takeEvery(predicateCurrentIds('projectId'), onProjectChange);
  yield takeEvery(predicateCurrentIds('modelId'), onModelChange);
  yield takeEvery('REFRESH', onRefresh);
}
